// <sm-press-carousel>: arrows and dots step one logo at a time; autoplay loops, pauses on hover/focus and with reduced motion.
if (!customElements.get('sm-press-carousel')) {
  customElements.define('sm-press-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sm-press-carousel__track');
      this.dotsEl = this.querySelector('.sm-press-carousel__dots');
      this.arrows = [...this.querySelectorAll('.sm-press-carousel__arrow')];
      this.arrows.forEach((a) => a.addEventListener('click', () => this.go(this.index() + Number(a.dataset.dir), true)));
      this.onScroll = () => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(() => this.sync()); };
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.ro = new ResizeObserver(() => this.build());
      this.ro.observe(this.track);
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.dataset.autoplay === 'true' && !reduce) {
        this.paused = false;
        ['mouseenter', 'focusin'].forEach((e) => this.addEventListener(e, () => { this.paused = true; }));
        ['mouseleave', 'focusout'].forEach((e) => this.addEventListener(e, () => { this.paused = false; }));
        this.timer = setInterval(() => { if (!this.paused && !document.hidden) this.go(this.index() + 1 > this.max() ? 0 : this.index() + 1); }, 3500);
      }
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      this.ro?.disconnect();
      this.track?.removeEventListener('scroll', this.onScroll);
    }

    items() { return [...this.track.children]; }
    step() { return this.items()[0]?.getBoundingClientRect().width || 1; }
    perView() { return Math.max(1, Math.round(this.track.clientWidth / this.step())); }
    max() { return Math.max(0, this.items().length - this.perView()); }
    index() { return Math.round(this.track.scrollLeft / this.step()); }

    go(i, user) {
      const n = Math.min(Math.max(i, 0), this.max());
      this.track.scrollTo({ left: n * this.step() });
      if (user) this.paused = true;
    }

    build() {
      const count = this.max() + 1;
      this.querySelector('.sm-press-carousel__nav').hidden = count < 2;
      if (this.dotsEl.children.length !== count) {
        this.dotsEl.replaceChildren(...Array.from({ length: count }, (_, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'sm-press-carousel__dot';
          b.setAttribute('aria-label', `${this.dataset.labelDot || ''} ${i + 1}`.trim());
          b.addEventListener('click', () => this.go(i, true));
          return b;
        }));
      }
      this.sync();
    }

    sync() {
      const i = this.index();
      [...this.dotsEl.children].forEach((d, n) => d.setAttribute('aria-current', String(n === i)));
      this.arrows[0].disabled = i <= 0;
      this.arrows[1].disabled = i >= this.max();
    }
  });
}
